import React from "react";
import { AddMasterDataProps } from "./Index";
import { Operation } from "../../../../../utils/Enum.types";
import { Title } from "../../../../../stories/Title/Title";
import { Label } from "../../../../../stories/Label/Label";
import InputHoc from "../../../../common/Input/Index";
import { LabelProps } from "../../../../../utils/types";
import { FormControlLabel } from "@mui/material";
import { AntSwitch } from "../../../../../styles/Switch";
import InputNumber from "../../../../common/Input/InputNumber";
import PredefinedUOM from "../../../../../customComponents/PredefinedUOM";
import useFormJson from "../../../../../json/useFormJson";
const Add = ({
  formData,
  handleValueChange,
  meta,
  setFormData,

  operation,
}: AddMasterDataProps) => {
  const { UomFormLabels } = useFormJson();
  return (
    <>
      <div className="master-data__add">
        <Title variant="subtitle1">
          {operation === Operation.UPDATE ? "Update" : "Add"} UOM
        </Title>
        <div className="master-data__add--form">
          {operation === Operation.UPDATE ? (
            <>
              <InputHoc
                LabelName="UOM"
                values={formData.uom}
                name="uom"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  handleValueChange(e, meta);
                }}
                disabled
              />
              <InputHoc
                LabelName="UOM Description"
                values={formData.uomDesc}
                name="uomDesc"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  handleValueChange(e, meta);
                }}
              />
            </>
          ) : null}

          {UomFormLabels.map((field: LabelProps, key: React.Key) => {
            if (field.dataType === "number") {
              return (
                <div className="label-grid" key={key}>
                  <Label>{field.labelName}</Label>
                  <InputNumber
                    value={formData[field.inputName]}
                    name={field.inputName}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleValueChange(e, meta)
                    }
                    required={field.required}
                    disabled={formData.useDecimals === false}
                    maxLength={field.maxLength}
                  />
                </div>
              );
            } else if (field.dataType === "boolean") {
              return (
                <FormControlLabel
                  label={field.labelName}
                  labelPlacement="start"
                  name={field.inputName}
                  control={
                    <AntSwitch
                      checked={formData.useDecimals}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          [field.inputName]: e.target.checked,
                        });
                      }}
                    />
                  }
                  className="master-data__add--form-labels"
                />
              );
            } else if (
              field.dataType === "uom" &&
              operation === Operation.CREATE
            ) {
              return (
                <div className="label-grid">
                  <Label>{field.labelName}</Label>
                  <PredefinedUOM
                    label=""
                    onChange={(newValue) => {
                      if (newValue) {            
                        setFormData({
                          ...formData,
                          uomDesc: newValue.value,
                          [field.inputName]: newValue.label,
                        });
                      } else {
                        setFormData({
                          ...formData,                       
                          uomDesc: "",
                          [field.inputName]:"",
                        });
                      }
                    }}
                    value={formData[field.inputName] as string}
                    autoFocus={field.autoFocus}
                  />
                </div>
              );
            } else if (
              field.dataType === "uom_desc" &&
              operation === Operation.CREATE
            ) {
              return (
                <InputHoc
                  LabelName={field.labelName}
                  values={formData.uomDesc}
                  name={field.inputName}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {                 
                    handleValueChange(e, meta);
                  }}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
    </>
  );
};

export default Add;
